import * as React from 'react'; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import Script from 'react-load-script';
import { Wrapper } from './ViewerContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ViewerContainer = /*#__PURE__*/React.forwardRef(({
  onLoad,
  onError,
  version
}, ref) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Wrapper, {
    ref: ref
  }), /*#__PURE__*/_jsx("link", {
    rel: "stylesheet",
    type: "text/css",
    href: `https://developer.api.autodesk.com/modelderivative/v2/viewers/style.min.css?v=v${version}`
  }), /*#__PURE__*/_jsx(Script, {
    url: `https://developer.api.autodesk.com/modelderivative/v2/viewers/viewer3D.min.js?v=v${version}`,
    onLoad: onLoad,
    onError: onError
  })]
}));
ViewerContainer.displayName = 'ViewerContainer';